import { styled } from 'linaria/react';
import { StyledInputWrapper as ImportedInputWrapper } from '../../AddContent/AddPick/styled';

export const StyledInputWrapper = styled(ImportedInputWrapper)`
  &::first-letter {
    text-transform: uppercase;
  }
`;
